<template>

  <div class="modal fade" id="AddParametreModal" tabindex="-1" role="dialog" ref="addParametreModalRef"
    aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="Parametre">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="parametreForm" @submit="addParametre" :validation-schema="parametreSchema">
            <div class="row">
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Clé <span class="text-danger">*</span>
                  </label>
                  <Field name="cle" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer la clé" />
                  <ErrorMessage name="cle" class="text-danger" />
                </div>
              </div>

              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Libelle <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libelle" />
                  <ErrorMessage name="libelle" class="text-danger" />
                </div>
              </div>

              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="dz-message needsclick">
                    <DropZone name="fichiers[]" :maxFilesize="50" :maxFiles="10" :uploadOnDrop="true"
                      @addedFile="onFileAdd" @removedFile="onFileRemove" :options="dropzoneOptions"
                      :existingFiles="urlImage">
                      <template v-if="!hasFiles">
                        <div class="default-image-container">
                          <img :src="defaultImage" alt="Default" class="default-image" />
                          <p>Glissez et dépossez ici</p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="dropzone-previews">
                          <div v-for="file in urlImage" :key="file.name" class="dropzone-preview">
                            <img v-if="file.url" :src="file.url" class="preview-image" />
                            <p>{{ file.name }}</p>
                          </div>
                        </div>
                      </template>
                    </DropZone>

                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">
                {{ btntext }}
              </button>
            </div>
          </Form>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch, reactive } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, hideModal, success, getUrlApiForFiles } from '@/utils/utils';
import { Parametre } from '@/models/Parametre';
import { useRouter } from 'vue-router';
import path from 'path-browserify';
import DropZone from "dropzone-vue";
import axios from 'axios';

export default {
  name: "AddParametreModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    DropZone

  },
  props: {
    id: {
      type: Number,
      required: true,
      default: 0
    },
  },
  emits: ["refreshParametres", 'openmodal'],

  setup: (props: any, { emit }: { emit: (event: string, payload?: any) => void }) => {

    const loading = ref<boolean>(false);
    const parametreSchema = Yup.object().shape({
      libelle: Yup.string().required('Le libelle est obligatoire'),
      cle: Yup.string().required('La clé est obligatoire'),
      photoFileName: Yup.mixed().notRequired(),
    });
    const parametrenew = ref(props.id);
    const parametreForm = ref<Parametre | null>(null);
    const addParametreModalRef = ref<null | HTMLElement>(null);
    let parametres = ref<Array<Parametre>>([]);
    const title = ref('Ajouter un parametre');
    const btntext = ref('Ajouter');
    const isupdate = ref(false);
    const router = useRouter();

    const defaultImage = path.join('/public', 'welcome2.png');
    const hasFiles = ref(false);
    const urlImage = ref<Array<File>>([])

    const selectedFile = ref<{ file: File | null, previewUrl: string | null }>({
      file: null,
      previewUrl: null
    });

    const photoFileNameChange = (e) => {
      const file = e.target.files[0];
      if (file) {
        selectedFile.value = {
          file: file,
          previewUrl: URL.createObjectURL(file)
        };
      }
    };
    const fileInput = ref();
    const imagePreview = ref<string | null>(null);
    const imageFile = ref(null);
    const triggerFileInput = () => {
      fileInput.value.click();
    };

    watch(() => props.id, (newValue) => {
      if (newValue != 0) {
        getParametre(newValue);
        isupdate.value = true;
      }
      btnTitle();
    });

    const getParametre = async (id: number) => {
      try {
        const { data } = await ApiService.get(`/parametres/${id}`);
        console.log("Données récupérées:", data);

        if (data.data) {
          parametreForm.value?.setFieldValue("id", data.data.id);
          parametreForm.value?.setFieldValue("libelle", data.data.libelle);
          parametreForm.value?.setFieldValue("cle", data.data.cle);

          if (data.data.medias && data.data.medias.length > 0) {
            urlImage.value = data.data.medias.map(media => ({
              id: media.id,
              name: media.nomMedia,
              size: 0,
              type: media.extension,
              url: getUrlApiForFiles('Parametres', media.nomMedia),
            }));
            hasFiles.value = true;
          } else {
            urlImage.value = [];
            hasFiles.value = false;
          }

          console.log("Médias chargés:", urlImage.value);
          emit('openmodal', addParametreModalRef.value);
        }
      } catch (err) {
        console.error("Erreur lors de la récupération du parametre:", err);
      }
    };


    const btnTitle = async () => {
      if (isupdate.value) {
        title.value = "Modifier le parametre";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter un parametre ";
        btntext.value = "Ajouter";
      }
    }

    const addParametre = async (values: any, { resetForm }: { resetForm: () => void }) => {
      values = values as Parametre;
      const id = values.id;
      delete values.createdAt;
      delete values.deletedAt;
      delete values.medias;
      delete values.updatedAt;
      delete values.addRef;
      delete values.id;
      console.log("Données", values);

      const fd = new FormData();
      fd.append('cle', values.cle);
      fd.append('libelle', values.libelle);
      if (imageFile.value) fd.append('urlImage', imageFile.value);
      urlImage.value.forEach(f => fd.append('autreFichier[]', f));
      


      //values['autreFichier[]'] = [];
      values["urlImage"] = [];

      if (urlImage.value.length > 0) {
        values['autreFichier[]'] = urlImage.value;
      }
      if (imageFile.value) {
        values["urlImage"] = imageFile.value;
      }
      const url = `parametres/${id}`;
      console.log(values, "valeur");
      loading.value = false;
      if (isupdate.value) {
        await axios.put(url, values, {
          headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
        }).then(({ data }) => {
          if (data.code == 200) {
            success(data.message);
            resetForm();
            hideModal(addParametreModalRef.value);
            isupdate.value = false;
            btnTitle();
            emit("refreshParametres");
            router.push('/liste-parametre');
          }
        }).catch(({ response }) => {
          error(response.data.message);
        });
      } else {
       axios.post('parametre', fd, { headers: { 'Content-Type': undefined } })
// ne pas fixer Content-Type manuellement
        // axios.post("parametre", values, {
        //   headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
        // })
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message)
            resetForm();
            hideModal(addParametreModalRef.value);
            emit("refreshParametres");
          }
        }).catch(({ response }) => {
          error(response.data.message);
        });
      }
    };

    const onFileAdd = (file: any) => {
      console.log("Fichier ajouté ===> ", file);
      urlImage.value.push(file["file"]);
      hasFiles.value = true;
    };
    const onFileRemove = (file: File) => {
      console.log("Fichier retiré ==> ", file);
      const index = urlImage.value.findIndex(fil => ((fil.name === file["file"].name) && (fil.size === file["file"].size) && (fil.type === file["file"].type)));
      if (index !== -1) {
        urlImage.value.splice(index, 1);
      } else {
        console.log(`Le fichier ${file["file"].name} n'a pas été trouvé dans le tableau.`);
      }
      hasFiles.value = urlImage.value.length > 0;
    };

    const images = reactive([
      {
        file: null as File | null,
        previewUrl: null as string | null,
      },
    ]);

    const dropzoneOptions = {
      url: 'your-upload-url',
      thumbnailWidth: 150,
      maxFilesize: 50,
      maxFiles: 10,
      headers: { "My-Awesome-Header": "header value" },
      acceptedFiles: 'image/*',
    };
    const onSuccess = (file) => {
      console.log('Upload réussi:', file);
    };

    const onError = (file, message) => {
      console.error('Erreur de téléchargement:', message);
    };

    const onFilePrinChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target) {
            imagePreview.value = e.target.result as string;
          }
        };
        reader.readAsDataURL(file);
      }
    };

    const removeImage = (index: number) => {
      // Supprimer l'image au niveau de l'index donné
      urlImage.value.splice(index, 1);
      hasFiles.value = urlImage.value.length > 0;
    };


    const onFileChange = (event, index) => {
      const file = event.target.files[0];
      if (file) {
        images[index].previewUrl = URL.createObjectURL(file);
        images[index].file = file;
      }
    };
    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isupdate.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return {
      parametres, title, btntext, resetValue, parametreSchema,
      addParametre, parametreForm, addParametreModalRef, parametrenew,
      onFilePrinChange,
      hasFiles,
      onFileRemove,
      onFileAdd,
      urlImage,
      triggerFileInput,
      onSuccess,
      onError,
      dropzoneOptions,
      onFileChange,
      defaultImage,
      removeImage,
      photoFileNameChange,
      fileInput,
      imagePreview,
      imageFile,
      selectedFile,
      getUrlApiForFiles,
    };
  },
};
</script>@/models/Parametre

<style scoped>
.image-item {
  position: relative;
  margin-right: 10px;
  /* Ajouter de l'espace entre les éléments */
  margin-bottom: 10px;
  /* Espacement entre les images */
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  cursor: pointer;
  padding: 5px;
  /* Ajout de padding pour donner de l'espace autour de l'icône */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.3s ease;
}

.remove-btn:hover {
  background: darkred;
  /* Assombrir la couleur de fond au survol */
}

.preview-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
  /* Ajouter de l'espace sous l'image */
}

.uploaded-images {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  background: #f9f9f9;
}

.image-list {
  display: flex;
  gap: 10px;
}

.image-item {
  position: relative;
}

.preview-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid #ddd;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  cursor: pointer;
}

.dropzone-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 240px;
  border: 2px dashed #4caf50;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f8f8;
  position: relative;
}

.preview-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  padding: 5px 8px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
}

.delete-btn:hover {
  background: darkred;
}
</style>